var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_2273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2502 14.9922C10.5934 14.9922 9.25024 16.3353 9.25024 17.9922V23.9922H15.2502V17.9922C15.2502 16.3353 13.9071 14.9922 12.2502 14.9922Z",
    fill: "#1DB469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2503 17.9924V23.9924H21.2502C22.9071 23.9924 24.2502 22.6492 24.2502 20.9924V11.8714C24.2505 11.3519 24.0486 10.8527 23.6872 10.4794L15.1893 1.29236C13.6898 -0.329979 11.1591 -0.429588 9.53679 1.06985C9.45973 1.1411 9.38548 1.2153 9.31428 1.29236L0.83126 10.4764C0.458979 10.8512 0.250104 11.3581 0.250244 11.8864V20.9924C0.250244 22.6492 1.5934 23.9924 3.25024 23.9924H7.25023V17.9924C7.26893 15.2656 9.47051 13.0388 12.1287 12.9747C14.8757 12.9084 17.2293 15.1731 17.2503 17.9924Z",
    fill: "#1DB469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2502 14.9922C10.5934 14.9922 9.25024 16.3353 9.25024 17.9922V23.9922H15.2502V17.9922C15.2502 16.3353 13.9071 14.9922 12.2502 14.9922Z",
    fill: "#1DB469"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_2273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.250244)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveHome);
export default __webpack_public_path__ + "static/media/activeHome.fe043f0e9e90cfa4eda08a4813396bdd.svg";
export { ForwardRef as ReactComponent };